import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ENVIRONMENT } from '@environments/environment';
import { IAuthModel } from './models/body/auth.model';
import { ICommonResponseAdApisModel, ICommonResponseApisModel } from '@api/common/models/common-response.model';
import { catchError, tap } from 'rxjs/operators';
import { IForgotPasswordModel } from './models/body/forgot-password.model';
import { IForgotPasswordResponseModel } from './models/response/forgot-password-response.model';
import { firstValueFrom } from 'rxjs';
import { AuthResponseModel } from './models/response/auth-response.model';
import { TokenService } from '../../services/token.service';
import { handlerErrorHelper } from '@api/helpers/handler-error.helper';
import { checkInterceptor } from '../../interceptors/token.interceptor';

@Injectable({
    providedIn: 'root',
})
export class AuthService {
    constructor(private http: HttpClient, private tokenService: TokenService) { }

    public authExternal(login: IAuthModel) {
        return firstValueFrom(
            this.http
                .post<ICommonResponseApisModel<AuthResponseModel>>(`${ENVIRONMENT.BASE_URL_API}/users/login`, login, {
                    context: checkInterceptor()
                })
                .pipe(tap((response: any) => this.tokenService.saveToken(response.data.token)))
                .pipe(catchError(handlerErrorHelper))
        );
    }

    public forgotPassword(forgotPassword: IForgotPasswordModel) {
        return firstValueFrom(
            this.http
                .post<ICommonResponseApisModel<IForgotPasswordResponseModel>>(
                    `${ENVIRONMENT.BASE_URL_API}/users/ask-new-password`,
                    forgotPassword,
                    {
                        context: checkInterceptor()
                    }
                )
                .pipe(catchError(handlerErrorHelper))
        );
    }

    public adGetLink() {
        return firstValueFrom(
            this.http
                .get<ICommonResponseAdApisModel<any>>(`${ENVIRONMENT.BASE_URL_API}/users/ad-auth-get-link`)
                .pipe(catchError(handlerErrorHelper))
        );
    }

    public adGetToken(params: any) {
        return firstValueFrom(
            this.http
                .get<ICommonResponseAdApisModel<any>>(`${ENVIRONMENT.BASE_URL_API}/users/ad-auth-get-token`, { params })
                .pipe(tap((response: any) => this.tokenService.saveToken(response.data.token)))
                .pipe(catchError(handlerErrorHelper))
        );
    }
}
